import React, { useMemo } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import MuiCheckbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import { useController } from 'react-hook-form'
import { InputFieldBase } from '../types'
import ErrorMessage from '../../ErrorMessage'
import ReactMarkdown from 'react-markdown'
import { useTheme } from '@mui/material/styles'

export type CheckboxProps = InputFieldBase

export const Checkbox: React.FC<CheckboxProps> = ({ label, control, required, disabled, ...props }) => {
  const fieldName = props.name!
  const { field, fieldState } = useController({ name: fieldName, control, rules: { required: required! } })
  const hasError = Boolean(fieldState.error)

  const { typography } = useTheme()
  const styles = {
    formControlLabel: {
      paddingBottom: hasError ? 0 : '18px', //combined with padding from checkbox for ~24px
      marginLeft: '-8px',
      '& > span:first-child': {
        alignSelf: 'baseline',
      },
      '& * > p': {
        ...typography.body1,
        margin: '8px 0px 14px 0px',
        textAlign: 'start',
        fontSize: '14px',
      },
      '& > div > span:nth-child(2)': {
        display: 'none',
      },
    },
    errorLabel: {
      margin: '8px 0 0 0',
      paddingBottom: '24px',
    },
  }

  return (
    <div>
      <FormControlLabel
        sx={styles.formControlLabel}
        control={
          <MuiCheckbox {...props} {...field} checked={Boolean(field.value)} disabled={disabled!} required={required!} />
        }
        label={<ReactMarkdown>{label!}</ReactMarkdown>}
      />
      {required && hasError && (
        <FormHelperText error variant="standard" sx={styles.errorLabel}>
          <ErrorMessage>
            <>{fieldState.error?.message}</>
          </ErrorMessage>
        </FormHelperText>
      )}
    </div>
  )
}
